import React, { useContext } from 'react'
import { Button, Card, CardHeader, Col, Input, Row } from 'reactstrap';
import NumberFormat from 'react-number-format';
import { CurrencyContext } from '../../context/Context';

const SelectCuentasListItem = ({
    title,
    alternativeName,
    id,
    /*    onSelect,
       selected, */
    createdAt,
    account,
    owner_name,
    owner_dni,
    isPending,
    categoryLabel,
    rate,
    convertedValue,
    currencyIso,
}) => {
    const { currency: curr } = useContext(CurrencyContext);
    const effectiveRate = Number(rate ?? curr?.value ?? 0);
    const hasConvertedValue = convertedValue !== undefined && convertedValue !== null;
    const showConverted = hasConvertedValue || (effectiveRate > 0 && effectiveRate !== 1);
    const convertedAmount = hasConvertedValue
        ? Number(convertedValue)
        : account
        ? Number(account) * effectiveRate
        : 0;
    const quoteIso = currencyIso ?? curr?.currency?.iso ?? "";
    const Badge = ({ children, color }) => (
        <span className={`badge badge-soft-${color} ml-2`} style={{ fontSize: '0.7rem' }}>
            {children}
        </span>
    );

    const jsUcfirst = (string) => { return string.charAt(0).toUpperCase() + string.slice(1); }

    const getDate = (date) => { var d = new Date(date); return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`; }

    return (
        <Card className="shadow-none border-top" data-testid="CondominiumItem">
            <CardHeader style={{ background: 'none' }} >
                <Row>
                    {/*      <Col xs={6} className="d-flex align-items-center">
                            <div className='m-0'>
                                <h6 className='m-0'>{title}</h6>
                                {createdAt && <p className='mb-0'>
                                    {jsUcfirst(alternativeName)} creado el <span data-testid="date" >{getDate(createdAt)}</span>
                                </p>}
                            </div>
                        </Col> */}
                    <Col xs={6} className="d-flex align-items-center">
                        <div className="media-body">
                            <h6 className="mb-0 font-weight-semi-bold">
                                <span className="text-900">Descripción</span>
                            </h6>
                            <p className="m-0">
                                {owner_name}
                                {/* Sin esto no se distingue a que categoria
                                    pertenece cada linea, y el listado filtrado
                                    por categoria se ve igual que el completo. */}
                                {categoryLabel && <Badge color="secondary">{categoryLabel}</Badge>}
                                {isPending && <Badge color="warning">Pendiente de aprobación</Badge>}
                            </p>
                        </div>
                    </Col>
                    {/*    <Col xs={6} className="d-flex align-items-center">
                            <div className="media-body">
                                <h6 className="mb-0 font-weight-semi-bold">
                                    <span className="text-900">DNI</span>
                                </h6>
                                <p className="m-0">{owner_dni}</p>
                            </div>
                        </Col> */}
                    <Col xs={5} className="d-flex align-items-center border-left">
                        <div className="media-body">
                            <h6 className="mb-0 font-weight-semi-bold">
                                <span className="text-900">Monto</span>
                            </h6>
                            <p className="m-0">
                                <NumberFormat thousandSeparator={true} prefix='$ ' displayType="text" decimalScale={2} fixedDecimalScale value={account ?? 0} />
                                {showConverted && (
                                    <NumberFormat
                                        thousandSeparator={true}
                                        prefix={" | " + quoteIso + " "}
                                        displayType="text"
                                        decimalScale={2}
                                        fixedDecimalScale
                                        value={convertedAmount}
                                    />
                                )}
                            </p>
                        </div>

                    </Col>
                    {/*    <Col xs={1} className="d-flex align-items-center">

                            <Input
                                name="propertyDebtsToPay"
                                type="checkbox"
                                checked={selected}
                            />

                        </Col> */}
                </Row>
            </CardHeader>
        </Card>
    )
}


export default SelectCuentasListItem;